import { useAnalytics } from "./analytics-provider/analytics-provider.mjs";
const useAnalyticsTrigger = (trigger, childProps) => {
  const { push } = useAnalytics();
  const triggers = Array.isArray(trigger) ? trigger : [trigger];
  return triggers.reduce((prevProps, currentTrigger) => {
    const { id, callback, elementId, interactionType, ...rest } = currentTrigger;
    return {
      ...prevProps,
      [callback]: (...args) => {
        push(
          typeof id === "function" ? id(args) : id,
          typeof elementId === "function" ? elementId(args) : elementId,
          typeof interactionType === "function" ? interactionType(args) : interactionType,
          rest
        );
        const childCallback = childProps == null ? void 0 : childProps[callback];
        if (childCallback) {
          childCallback(...args);
        }
      }
    };
  }, {});
};
export {
  useAnalyticsTrigger
};
